import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as FiltersActions from 'common/filter/actions/filtersActions'

class FieldValuesController extends Component {
  componentDidMount() {
    const { fieldDesc, value } = this.props
    this.props.fetchFieldValues(fieldDesc.id, value || '')
  }

  render() {
    return React.cloneElement(this.props.children, this.props)
  }
}

export default connect(
  (state) => ({ ...state.filter.values }),
  (dispatch) => bindActionCreators(FiltersActions, dispatch),
)(FieldValuesController)
